<template>
    <v-card flat>
      <v-card-title class="title style-color-main-gray">
        <span>Список событий, привязанных к администратору</span>
        <v-spacer></v-spacer>

      </v-card-title>
      <v-data-table
          :headers="headers"
          :items="getItems"
          :loading="isLoading"
          :page.sync="pagination.page"
          :items-per-page.sync="pagination.size"
          :options.sync="options"
          :server-items-length="getCount"
          :footer-props="{'items-per-page-options':[25,50,100]}"
          class="elevation-2 rounded-b-lg rounded-t-0"
          style="cursor: pointer"
          @click:row="goDetail"
      >
        <template v-slot:item.date_opened="{item}">
          {{ displayDate(item.date_opened,true) }}
        </template>
        <template v-slot:item.date_closed="{item}">
          {{ displayDate(item.date_closed,true) }}
        </template>
        <template v-slot:item.start_date="{item}">
          {{ displayDate(item.start_date) }}
        </template>
        <template v-slot:item.end_date="{item}">
          {{ displayDate(item.end_date) }}
        </template>
        <template v-slot:no-data>
          <v-card-text>Данные не загружены</v-card-text>
        </template>
      </v-data-table>
    </v-card>
</template>


<script>
import UserDataMixin from '@/mixins/UserDataMixin'
import {loadData} from "@/helper/requests";
import PaginatedDataMapperMixin from "@/mixins/PaginatedDataMapperMixin";
import urls from '@/urls/helper.js'
import names from "@/modules/recording/routers/names";
import {mapActions, mapGetters} from "vuex";
import {displayDate} from "../../../../helper";
import {generateListUidToName} from "@/helper/uidToName";

export default {
  name: "List",
  mixins: [
    PaginatedDataMapperMixin,
  ],

  components: {

  },
  computed: {
    ...mapGetters({
      getItems: 'event_admin/getEvents',
      getCount: 'event_admin/getEventsCount',
      isLoading: 'event_admin/isLoadingEvents',
    }),
  },
  data() {
    return {
      headers: [
        {text: 'Название', sortable: false, align: 'left', value: "name",},
        {text: 'Дата открытия', sortable: false, align: 'left', value: "date_opened",},
        {text: 'Дата закрытия', sortable: false, align: 'left', value: "date_closed",},
        {text: 'Дата начала', sortable: false, align: 'left', value: "start_date",},
        {text: 'Дата окончания', sortable: false, align: 'left', value: "end_date",},
        {text: 'Описание', sortable: false, align: 'left', value: "description",},
      ]
    }
  },
  created() {
    this.loadData();
  },
  methods: {
    displayDate,
    ...mapActions({
      loadList: 'event_admin/loadEventsList',
    }),
    goDetail(item){
      this.$router.push({
        name: names.ADMINEVENTS.DETAIL,
        params: { event: item.id },
      })
    },
    loadData(url = undefined) {
      this.loadList({
        url: url,
        urlAppend: (url) => {
          return this.addPageParameter(this.addSizeParameter(url));
        },
        finalizer: (data, url) => {
          this.setCurrentLoadUrl(url)
        }
      })
    },
  }
}
</script>

<style scoped>
  .row-pointer >>> tbody tr :hover {
    cursor: pointer;
  }
</style>
